import { Component, DoCheck, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AlertService, AuthenticationService, ShadowService } from 'src/app/shared/_services';
import { DashboardStore, WithdrawStore } from 'src/app/shared/_services/store';

@Component({
  selector: 'app-withdraw',
  templateUrl: './withdraw.page.html',
  styleUrls: ['./withdraw.page.scss'],
})
export class WithdrawPage implements OnInit, DoCheck {
  accountNumber: string;
  bank: string;
  balance: any;
  loading = false;
  disabled = true;
  withdrawalForm: FormGroup;
  errorAmount = true;
  withdrawDetails: any;
  subscription: any;
  accountSummary = this.dashboardStore.getAccountSummary();

  constructor(
    private router: Router,
    private platform: Platform,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private auth: AuthenticationService,
    private withdrawStore: WithdrawStore,
    private dashboardStore: DashboardStore,
    private shadowService: ShadowService,
  ) {
    this.accountNumber = !this.accountSummary ?
    this.auth.currentUserValue.details.accountNumber : this.accountSummary.details.accountNumber;
    this.bank = !this.accountSummary ?
    this.auth.currentUserValue.details.bank : this.accountSummary.details.bank;
  }

  get amount() {
    return this.withdrawalForm.get('amount');
  }

  get password() {
    return this.withdrawalForm.get('password');
  }

  public errorMessages = {
    amount: [
      { type: 'required', message: 'Amount is required' },
      { type: 'pattern', message: 'Amount can only contain numbers or decimals' },
    ],
    password: [
      { type: 'required', message: 'Password is required' },
      { type: 'minlength', message: 'Password can\'t be less than 8 characters' },
    ]
  };

  withdrawFunds() {
    this.loading = true;
    this.disabled = true;
    this.auth.withdrawFunds(this.amount.value, this.password.value)
    .subscribe(
      response => {
        this.loading = false;
        console.log(response);
        const details = JSON.stringify(response);
        this.withdrawDetails = JSON.parse(details);
        if (this.withdrawDetails.message.includes('Insufficient funds')) {
          this.alertService.standardAlert('Insufficient Funds');
        } else {
          this.alertService.standardToastWithOptions(
            'Yaay!', '<strong>₦' + this.amount.value + '</strong> has been succesfully withdrawn.'
          );
          setTimeout(() => {
            this.router.navigateByUrl('/dashboard');
          }, 2000);
        }
      },
      error => {
        this.loading = false;
        console.error(error);
        if (error.status === 422) {
          this.alertService.standardAlert('Password Incorrect. Please try again');
        } else {
          this.alertService.standardAlert('Unable to withdraw funds. Please try again');
        }
      }
    );
  }

  history() {
    this.router.navigateByUrl('/withdrawal-history');
  }

  showTooltip(ev: any) {
    this.alertService.showWithdrawTooltip(ev);
  }

  goBack() {
    this.router.navigateByUrl('/dashboard');
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      if (this.constructor.name === 'WithdrawPage') {
        this.alertService.checkForAlert();
      } else {
        this.goBack();
      }
    });
  }

  ionViewWillEnter() {
    document.title = 'Withdraw Funds | Bank3D';
    this.shadowService.button();
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    if (!this.withdrawStore.getIsWithdrawTooltipTapped()) {
      setTimeout(() => {
        this.showTooltip(null);
      }, 500);
    }
    this.balance = this.dashboardStore.getBalance();
    this.withdrawalForm = this.formBuilder.group({
      amount: [
        '', [Validators.required, Validators.pattern('^(\\d*\\.)?\\d+$')]
      ],
      password: [
        '', [Validators.required, Validators.minLength(8)]
      ]
    });
    window.onpopstate = (() => {
      this.alertService.checkForAlert();
    });
  }

  ngDoCheck(): void {
    !this.withdrawalForm.valid ? this.disabled = true : this.disabled = false;
    this.balance < this.amount.value ? this.errorAmount = true : this.errorAmount = false;
    if (this.amount.value > this.balance) { this.disabled = true; }
  }
}
